(function () {
  function message(moq) {
    var template = (window.moqSettings && window.moqSettings.errorMessage) || 'Minimum order quantity for this item is [X] units';
    return template.replace('[X]', moq);
  }

  function showProductError(input, moq) {
    var form = input.closest('form');
    var err = (form && form.querySelector('[data-moq-error]')) || document.querySelector('[data-moq-error]');
    if (!err) return;
    err.textContent = message(moq);
    err.hidden = false;
    err.style.display = 'block';
    err.style.color = '#c0392b';
    err.style.marginTop = '6px';
  }

  function hideProductError(input) {
    var form = input.closest('form');
    var err = (form && form.querySelector('[data-moq-error]')) || document.querySelector('[data-moq-error]');
    if (err) err.hidden = true;
  }

  function showRowError(btnOrInput, moq) {
    var line = btnOrInput && btnOrInput.dataset ? btnOrInput.dataset.line : null;
    if (!line) return;
    var scope = btnOrInput.closest('tr, .mini-cart__line-item') || document;
    var err = scope.querySelector('[data-moq-error-line="' + line + '"]');
    if (!err) {
      err = document.querySelector('[data-moq-error-line="' + line + '"]');
    }
    if (!err) return;
    err.textContent = message(moq);
    err.hidden = false;
    err.style.display = 'block';
    err.style.color = '#c0392b';
    err.style.marginTop = '6px';
  }

  function clampProductInputs() {
    document.querySelectorAll('input[name="quantity"][data-moq]').forEach(function (input) {
      var moq = parseInt(input.dataset.moq, 10);
      if (!moq || moq <= 1) return;
      if ((parseInt(input.value, 10) || 0) < moq) input.value = moq;
    });
  }

  function initProductPage() {
    clampProductInputs();
  }

  function initCartPage() {
    var checkoutBtn = document.querySelector('button[name="checkout"]');
    if (checkoutBtn && checkoutBtn.dataset.moqBound !== '1') {
      checkoutBtn.dataset.moqBound = '1';
      var cartForm = checkoutBtn.closest('form');
      var handler = function (e) {
        var offenders = [];
        document.querySelectorAll('input.quantity-selector__value[data-moq]').forEach(function (input) {
          var moq = parseInt(input.dataset.moq, 10);
          var cur = parseInt(input.value, 10);
          if (moq && !isNaN(cur) && cur < moq) offenders.push({ input: input, moq: moq });
        });
        if (offenders.length) {
          e.preventDefault();
          e.stopImmediatePropagation();
          offenders.forEach(function (o) { showRowError(o.input, o.moq); });
        }
      };
      if (cartForm) cartForm.addEventListener('submit', handler, true);
      checkoutBtn.addEventListener('click', handler, true);
    }
  }

  function init() {
    initProductPage();
    initCartPage();
  }

  // Reset quantity to the new variant's default after the theme's product:rerender
  // swaps the variant-selector block. The theme's onRerender restores the previous
  // quantity value, which fights the "act like a refresh" behavior we want when
  // the new variant has a different MOQ. variant:changed fires synchronously
  // before product:rerender, so defer via microtask to run after the swap.
  document.addEventListener('variant:changed', function (e) {
    queueMicrotask(function () {
      var form = e.target && e.target.tagName === 'FORM'
        ? e.target
        : document.querySelector('form.product-form');
      if (!form) return;

      var qtyInput = form.querySelector('input[name="quantity"]');
      if (!qtyInput) return;

      var moq = parseInt(qtyInput.getAttribute('data-moq'), 10);
      var min = parseInt(qtyInput.getAttribute('min'), 10);
      qtyInput.value = moq || min || 1;

      var err = form.querySelector('[data-moq-error]') || document.querySelector('[data-moq-error]');
      if (err) err.hidden = true;
    });
  });
  document.addEventListener('variant:changed', function (e) {
    var variant = e && e.detail && e.detail.variant;
    var formId = e && e.detail && e.detail.formId && e.detail.formId.id;
    var form = formId ? document.getElementById(formId) : (e.target && e.target.tagName === 'FORM' ? e.target : null);
    if (!form) form = document.querySelector('form.product-form');
    if (!form) return;

    var qtyInput = form.querySelector('input[name="quantity"]');
    if (qtyInput && variant && variant.quantity_rule) {
      var rule = variant.quantity_rule;
      if (rule.min != null) qtyInput.min = rule.min;
      if (rule.increment != null) qtyInput.step = rule.increment;
      if (rule.max != null) qtyInput.max = rule.max;
      else qtyInput.removeAttribute('max');
    }

    var buyContainer = form.querySelector('.product-form__payment-container');
    var buyBtn = buyContainer && buyContainer.querySelector('.product-form__add-button');
    if (buyBtn) {
      if (!variant) {
        buyBtn.setAttribute('disabled', 'disabled');
        buyBtn.type = 'button';
        buyBtn.classList.add('button--disabled');
        buyBtn.classList.remove('button--primary');
        buyBtn.textContent = 'Unavailable';
      } else if (!variant.available) {
        buyBtn.setAttribute('disabled', 'disabled');
        buyBtn.type = 'submit';
        buyBtn.classList.add('button--disabled');
        buyBtn.classList.remove('button--primary');
        buyBtn.textContent = 'Sold out';
      } else {
        buyBtn.removeAttribute('disabled');
        buyBtn.type = 'submit';
        buyBtn.classList.remove('button--disabled');
        buyBtn.classList.add('button--primary');
        buyBtn.textContent = 'Add to cart';
      }
    }
  });

  document.addEventListener('cart:refresh', init);
  document.addEventListener('cart:change', init);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[data-action="decrease-quantity"][data-moq]');
    if (!btn) return;
    var moq = parseInt(btn.dataset.moq, 10);
    if (!moq || moq <= 1) return;
    var target = parseInt(btn.dataset.quantity, 10);
    if (!isNaN(target) && target > 0 && target < moq) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showRowError(btn, moq);
    }
  }, true);

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('input.quantity-selector__value[data-moq]');
    if (!input) return;
    var moq = parseInt(input.dataset.moq, 10);
    if (!moq || moq <= 1) return;
    var val = parseInt(input.value, 10);
    if (!isNaN(val) && val > 0 && val < moq) {
      e.preventDefault();
      e.stopImmediatePropagation();
      input.value = moq;
      showRowError(input, moq);
    }
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-action="decrease-picker-quantity"]');
    if (!btn) return;
    var picker = btn.closest('quantity-picker') || btn.parentElement;
    var input = picker && picker.querySelector('input[name="quantity"][data-moq]');
    if (!input) return;
    var moq = parseInt(input.dataset.moq, 10);
    if (!moq || moq <= 1) return;
    var cur = parseInt(input.value, 10);
    if (isNaN(cur) || cur <= moq) {
      showProductError(input, moq);
    }
  }, true);

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('input[name="quantity"][data-moq]');
    if (!input) return;
    var moq = parseInt(input.dataset.moq, 10);
    if (!moq || moq <= 1) return;
    var val = parseInt(input.value, 10);
    if (!isNaN(val) && val < moq) {
      input.value = moq;
      showProductError(input, moq);
    } else if (!isNaN(val) && val > moq) {
      hideProductError(input);
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var input = form.querySelector('input[name="quantity"][data-moq]');
    if (!input) return;
    var moq = parseInt(input.dataset.moq, 10);
    if (!moq || moq <= 1) return;
    if ((parseInt(input.value, 10) || 0) < moq) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showProductError(input, moq);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
